import { render, staticRenderFns } from "./pool.vue?vue&type=template&id=0bd7764a&scoped=true"
import script from "./pool.vue?vue&type=script&lang=js"
export * from "./pool.vue?vue&type=script&lang=js"
import style0 from "./pool.vue?vue&type=style&index=0&id=0bd7764a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd7764a",
  null
  
)

export default component.exports